// useWakeServer.jsx
import { useState } from 'react';
import useLastWake from './useLastWake';

function useWake() {
  const [isWaking, setIsWaking] = useState(false);
  const { lastWake, updateLastWake } = useLastWake(); // Consume context

  const wakeServer = async () => {
    setIsWaking(true);
    try {
      const response = await fetch(
        'https://gartekweb.onrender.com/wakeserver',
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to wake server');
      }

      updateLastWake();
    } finally {
      setIsWaking(false);
    }
  };

  const shouldWakeServer = () => {
    const now = Date.now();
    return !lastWake || now - lastWake > 20 * 60 * 1000; // 20 minutes
  };

  return { isWaking, wakeServer, shouldWakeServer };
}

export default useWake;
